import { queryClient } from 'stateManagement/queries/client';

export const handleGetTransactionData = async ({ action }) => {
  const {
    params: { chain, txnHash },
  } = action;
  try {
    const transactionDecoderData = queryClient.getQueryData([
      'transaction-decoder',
      chain,
      txnHash,
    ]);

    let toReturn = {
      rawData: transactionDecoderData,
    };

    return toReturn;
  } catch (error) {
    console.error('Failed to extract transaction decoder data', error);
    return null;
  }
};
